import { lazy } from "react";

export default [
  {
    path: ["", "/"],
    component: lazy(() => import("src/views/stripe/StripeIndex")),
  },
];
